import { render, staticRenderFns } from "./TransactionDetail.vue?vue&type=template&id=2d467621&scoped=true"
import script from "./TransactionDetail.vue?vue&type=script&lang=ts"
export * from "./TransactionDetail.vue?vue&type=script&lang=ts"
import style0 from "./TransactionDetail.vue?vue&type=style&index=0&id=2d467621&lang=scss"
import style1 from "./TransactionDetail.vue?vue&type=style&index=1&id=2d467621&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d467621",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/sandeep/Work/EIOSYS/Cona-OSUM/Cona-Electrical-Admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2d467621')) {
      api.createRecord('2d467621', component.options)
    } else {
      api.reload('2d467621', component.options)
    }
    module.hot.accept("./TransactionDetail.vue?vue&type=template&id=2d467621&scoped=true", function () {
      api.rerender('2d467621', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/transaction/components/TransactionDetail.vue"
export default component.exports